import { ProjectsAssignedToProjectWorkersDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ProjectWorkers } from 'modules/project_management/hooks/projectWorker/useGetProjectsAssignedToWorker'

export type ProjectWorker = ProjectWorkers[number]

interface UseProjectsAssignedToEmployees {
  employeeIds: number[]
  skip?: boolean
  onCompleted?: (projectWorkers: ProjectWorker[]) => void
}

export const useProjectsAssignedToEmployees = ({
  employeeIds,
  skip,
  onCompleted,
}: UseProjectsAssignedToEmployees) => {
  const { loading, data } = useQuery(ProjectsAssignedToProjectWorkersDocument, {
    variables: { employeeIds, assigned: true, onlyActiveProjects: true, includeSubprojects: true },
    skip: !employeeIds.length || skip,
    onCompleted: (data) => onCompleted?.(data?.projectManagement?.projectWorkers ?? []),
  })

  return {
    loading,
    projectWorkers: data?.projectManagement?.projectWorkers ?? [],
  }
}
